import { fCurrency, fCurrencyCents } from './format-number';

export const REPORT_ZERO_VALUE = '—';

export function fReportCurrency(value: number | null | undefined): string {
  return Number(value ?? 0) === 0 ? REPORT_ZERO_VALUE : fCurrency(value ?? 0);
}

export function fReportCurrencyCents(cents: number | null | undefined): string {
  return Number(cents ?? 0) === 0 ? REPORT_ZERO_VALUE : fCurrencyCents(cents ?? 0);
}

export function fReportRefundCents(cents: number | null | undefined): string {
  const value = Math.abs(Number(cents ?? 0));
  return value === 0 ? REPORT_ZERO_VALUE : `(${fCurrencyCents(value)})`;
}
